import axios from 'axios';
import { v4 as uuid } from 'uuid';
import { Constant } from '../ApiRules/ApiRules';
import store from '../store';
import { AUTH_TOKEN_EXPIRED } from '../actions/actionTypes';

const tempMeeApi = axios.create({
  baseURL: Constant.BASE_URL,
  withCredentials: true,
});

tempMeeApi.interceptors.request.use((config) => ({
  ...config,
  headers: {
    ...{ 'x-correlation-id': uuid() },
    ...config.headers,
    'x-user-agent': navigator.userAgent,
  },
}));

tempMeeApi.interceptors.response.use(
  (response) => response,
  (error) => {
    const request = error.config;

    const isRefreshEndpoint =
      request.url.includes('auth/refresh') || request.url.includes('auth-service/sessions/refresh');
    if (isRefreshEndpoint && error.response && error.response.status === 403) {
      store.dispatch({ type: AUTH_TOKEN_EXPIRED });
    }

    return Promise.reject(error);
  },
);

export const callAuthServiceApi = async (method, url, data, params, headers) => {
  const normalizedUrl = url.startsWith('/') ? url : `/${url}`;
  const response = await tempMeeApi({
    method,
    url: `/auth-service${normalizedUrl}`,
    data,
    params,
    headers,
  });

  return response.data;
};

export default tempMeeApi;
